import { createContext, useContext, ReactNode } from 'react';
import { useAuth } from '@common/hooks/auth/useAuth';
import { AuthContextState } from './interfaces';

const AuthContext = createContext<AuthContextState | undefined>(undefined);

export const AuthContextProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const authState = useAuth();
  return <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>;
};

export const useAuthContextProvider = (): AuthContextState => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthContextProvider must be used within an AuthProvider');
  }
  return context;
};
